<p><a (click)="showDialog()">{{ value || setValueLabelLocalize }}</a></p>

<nz-modal [(nzVisible)]="isVisible" [nzTitle]="setValueTitleLocalize" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
  <ng-container *nzModalContent>
    <form nz-form nzLayout="vertical" [formGroup]="valueForm">
      <nz-form-item>
        <nz-form-label i18n>Значение</nz-form-label>
        <nz-form-control>
          <input nz-input type="date" formControlName="value">
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>
